import cn from "classnames"
import React from "react"

interface Props {
  className?: string
  disabled?: boolean
  label?: string
  onClick?: () => void
  icon?: string
  type: "primary" | "secondary"
}

const Button = (props: Props) => {
  const cursor = props.disabled ? "cursor-not-allowed" : "cursor-pointer"

  const handleClick = () => {
    if (props.disabled) return

    props.onClick?.()
  }

  if (props.type === "secondary")
    return (
      <React.Fragment>
        <div
          className={cn(
            "flex flex-row items-center border rounded-lg px-5 py-2 gap-2",
            props.disabled ? "border-gray-400 opacity-50" : "border-[#805AD5]",
            cursor,
            props.className,
          )}
          onClick={handleClick}
        >
          {Boolean(props.icon) && <img src={props.icon} alt="" />}

          <span className={props.disabled ? "text-gray-400" : "text-[#805AD5]"}>{props.label}</span>
        </div>
      </React.Fragment>
    )

  return (
    <React.Fragment>
      <div
        className={cn(
          "flex flex-row items-center border rounded-lg px-6 py-2 gap-2",
          props.disabled
            ? "bg-gray-400 border-gray-400 opacity-50"
            : "bg-[#805AD5] border-[#805AD5]",
          cursor,
          props.className,
        )}
        onClick={handleClick}
      >
        {Boolean(props.icon) && <img src={props.icon} alt="" />}

        <span className="text-white">{props.label}</span>
      </div>
    </React.Fragment>
  )
}

export default Button
